<template>
  <v-layout>
    <v-flex>
      <v-form ref="form" v-model="valid">
        <v-text-field v-if="note.id!==undefined" label="ID" v-model="note.id" disabled>
        </v-text-field>

           <v-menu
            ref="menuDate"
            v-model="menuDate"
            :close-on-content-click="false"
            :return-value.sync="note.date"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="note.date"
                label="Data interventie"
                prepend-icon="event"
                readonly
                v-on="on"
                :rules="dateRules"
              ></v-text-field>
            </template>
            <v-date-picker v-model="note.date" no-title scrollable>
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="menuDate = false">Cancel</v-btn>
              <v-btn text color="primary"
                @click="$refs.menuDate.save(note.date)">OK</v-btn>
            </v-date-picker>
          </v-menu>

        <v-text-field label="Message" v-model="note.message" :rules="messageRules" required>
        </v-text-field>

        <div class="text-xs-right">
          <v-btn @click="submit" color="primary">Salvare</v-btn>
        </div>
      </v-form>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  props: ['note', 'onSubmit'],
  data() {
    return {
      valid: true,
      menuDate: false,
      dateRules: [
        (element) => {
          if (element.trim() === '') return 'Data trebuie completata.';
          return true;
        },
      ],
      messageRules: [
        (element) => {
          if (element.trim() === '') return 'Mesajul trebuie completat.';

          return true;
        },
      ],
    };
  },
  methods: {
    submit() {
      if (this.$refs.form.validate() && this.valid) {
        this.onSubmit();
      }
    },
  },
};
</script>

<style>
</style>
